<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="5" :sm="10">
            <a-form-item label="项目编号">
              <a-input placeholder="请输入项目编号" v-model="queryParam.projNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="10">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="客户名称">
              <j-search-select-tag type="list" v-model="queryParam.customer" 
                dict="biz_customer,name,id" 
                :async = "true"
                placeholder="请输入至少两个汉字查询"/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="6">
            <a-form-item label="包含下级">
              <a-checkbox v-model="queryParam.includeSubCustomer">
              </a-checkbox>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="5" :sm="10">
              <a-form-item label="项目类型">
                <j-dict-select-tag
                  placeholder="请选择项目类型"
                  v-model="queryParam.type"
                  dictCode="bms_project_type">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="提交人">
                <j-search-select-tag
                  placeholder="请选择提交人"
                  v-model="queryParam.committer"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="10">
              <a-form-item label="申请人部门">
                <j-search-select-tag
                  placeholder="请选择申请人部门"
                  v-model="queryParam.committerDepart"
                  dict="sys_depart,depart_Name,org_Code">
                </j-search-select-tag>
              </a-form-item>
            </a-col> -->

            <a-col :md="6" :sm="8">
              <a-form-item label="提交日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.commitTimeRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="10">
              <a-form-item label="状态">
<!--                <j-dict-select-tag
                  placeholder="请选择项目状态"
                  v-model="queryParam.status"
                  dictCode="bms_project_status">
                </j-dict-select-tag>-->
                <a-select v-model="queryParam.status" placeholder="选择状态" :getPopupContainer= "(target) => target.parentNode" style="width: 150px">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="30">方案制作中</a-select-option>
                  <a-select-option value="31">方案审核中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--<a-col :md="5" :sm="10">
              <a-form-item label="风险点">
                <a-input placeholder="请输入风险点" v-model="queryParam.riskPoint1"/>
              </a-form-item>
            </a-col>-->
            <a-col :md="6" :sm="10">
              <a-form-item label="勘察情况">
                <a-input placeholder="请输入勘察情况" v-model="queryParam.surveyResult"/>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'projectRiskManageList:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleDownloadTemplate" v-has="'projectRiskManageList:downloadTemplate'">模板下载</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('风险管理与保险解决方案表')" v-has="'projectRiskManageList:export'">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(downUrl+text)">
            下载
          </a-button>
        </template>

        <span slot="longContent" slot-scope="text">
          <j-ellipsis :value="text" :length="10" />
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'projectRiskManageList:edit'" v-show="record.status== projectStatus.IDEA_WAIT">
                <a @click="handleEdit(record)">编辑</a> <!--v-has="'businessInfo:edit'" -->
              </a-menu-item>
              <a-menu-item v-has="'projectRiskManageList:del'" v-show="record.status== projectStatus.IDEA_WAIT">
                <a-popconfirm v-has="'businessInfo:del'" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'projectRiskManageList:commit'" v-show="record.status== projectStatus.IDEA_WAIT">
                <a  @click="handleCommit(record)" >提交审核</a>
              </a-menu-item>

              <a-menu-item v-has="'projectRiskManageList:return'" v-show="record.status== projectStatus.IDEA_AUDIT">
                <a @click="handleAudit(record, projectStatus.IDEA_WAIT)" >退回</a>
              </a-menu-item>
              <a-menu-item v-has="'projectRiskManageList:auditPass'" v-show="record.status== projectStatus.IDEA_AUDIT">
                <a @click="handleAudit(record, projectStatus.PURCHASE_WAIT)" >审核通过</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <project-risk-manage-modal ref="modalForm" @ok="modalFormOk"></project-risk-manage-modal>
    <a-modal v-model="templateModalVisible" title="模板下载" @ok="handleTemplateOK">
      <a style="margin-right:30px;" :href="`${path}风险管理方案.docx`" download="风险管理方案.docx">风险管理方案</a>
      <a style="margin-right:30px;" :href="`${path}保险解决方案.docx`" download="保险解决方案.docx">保险解决方案</a>
      <a style="margin-right:30px;" :href="`${path}风险管理和保险解决方案.docx`" download="风险管理和保险解决方案.docx">风险管理和保险解决方案</a>
    </a-modal>
    <a-modal v-model="modalVisible" :title="auditRemarkTitle" @ok="handleAuditRemarkOK">
      <label style="margin-bottom: 10px;display: block;">{{auditRemarkTitle}}：</label>
      <a-textarea rows="3" maxlength="255" placeholder="请输入简要描述" v-model="auditRemark" :trigger-change="true" />
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import { mapGetters } from 'vuex'
  import ProjectRiskManageModal from './modules/ProjectRiskManageModal'
  import ProjectStatus from '../ProjectStatus'
  import ProjectConst from '@views/project/ProjectConst'

  export default {
    name: 'ProjectRiskManageList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      JEllipsis,
      JDate,
      ProjectRiskManageModal,
    },
    data () {
      return {
        description: '风险管理列表',
        disableMixinCreated: true,
        modalVisible: false,
        templateModalVisible: false, // 模板下载窗口
        path: ProjectConst.OSS_ADR_TEMPLATE,
        projectStatus:{}, // 项目状态
        downUrl:window._CONFIG['downloadUrl'],

        auditRemark:'',// 审核不通过原因
        auditRemarkTitle:'撤销原因',
        currentRecord: null, // 撤销等操作时使用
        currentStatus: null,

        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目编号',
            className:'column-text',
            dataIndex: 'projNum',
            sorter: true
          },
          {
            title:'项目名称',
            className:"column-text",
            dataIndex: 'name',
          },
          {
            title:'状态',
            className:"column-text",
            dataIndex: 'statusName',
          },
          {
            title:'客户名称',
            className:"column-text",
            dataIndex: 'customerName'
          },
          {
            title:'查勘情况',
            className:"column-text",
            dataIndex: 'surveyResult',
            scopedSlots: {customRender: 'longContent'}
          },
          {
            title:'附件',
            className:"column-text",
            dataIndex: 'file',
            scopedSlots: {customRender: 'fileSlot'}
          },

          {
            title:'提交人',
            className:"column-text",
            dataIndex: 'committerName',
          },
          /*{
            title:'提交人部门',
            className:"column-text",
            dataIndex: 'applierDepartName'
          },*/
          {
            title:'提交时间',
            className:"column-text",
            dataIndex: 'commitTime',
          },
          {
            title:'审核人',
            className:"column-text",
            dataIndex: 'auditorName'
          },
          {
            title:'审核时间',
            className:"column-text",
            dataIndex: 'auditTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/project/riskmanage/list",
          delete: "/project/riskmanage/delete",
          commit: "/project/riskmanage/commit",
          audit: "/project/riskmanage/audit",
          exportXlsUrl: "/project/riskmanage/exportXls",
        },

      }
    },
    created() {
      this.projectStatus = ProjectStatus
    },
    methods: {
      ...mapGetters(["userInfo"]),

      handleCommit(record){
        // 提交申请
        postAction(this.url.commit,{id: record.id}).then(res =>{
          if(res.success){
            this.$message.success("提交完成")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      handleAudit(record, status){
        this.auditRemark=''
        this.currentRecord = record
        this.currentStatus = status

        if(status === this.projectStatus.IDEA_WAIT){ // 退回
          this.auditRemarkTitle ='退回原因'
          this.modalVisible = true

        } else if(status === this.projectStatus.PURCHASE_WAIT){ // 审核通过,保险采购
          this.audit()
        }
      },

      handleAuditRemarkOK(){
        if(this.auditRemark.length<=0){
          this.$message.warn(this.auditRemarkTitle + "不能为空")
          return
        } else if(this.auditRemark.length > 255){
          this.$message.warn(this.auditRemarkTitle + "长度不能超过255个字符")
          return
        }
        this.modalVisible = false;
        this.audit()
      },

      audit(){
        let record = this.currentRecord
        let status = this.currentStatus

        // 审核申请
        let param = {id: record.id, projId: record.projId,status: status,auditRemark: this.auditRemark}
        postAction(this.url.audit, param).then(res =>{
          if(res.success){
            this.$message.success("操作成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      onDateChange: function (value, dateString) {
        if(dateString.length >0 && dateString[0].length>0) {
          this.queryParam.commitTimeRange = dateString;
        } else {
          this.queryParam.commitTimeRange = null
        }
      },

      getQueryParams() {
        let param = Object.assign({}, this.queryParam, this.isorter ,this.filters)

        // 创建日期
        if(param.commitTimeRange){
          param.commitTimeBegin = param.commitTimeRange[0] + ' 00:00:00'
          param.commitTimeEnd = param.commitTimeRange[1] + ' 23:59:59'
          delete param.commitTimeRange
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      //模板下载
      handleDownloadTemplate(){
        this.templateModalVisible = true
      },
      handleTemplateOK(){
        this.templateModalVisible = false
      },

    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>